import { render, staticRenderFns } from "./DocumentItemLoader.vue?vue&type=template&id=0132de19"
import script from "./DocumentItemLoader.vue?vue&type=script&lang=js"
export * from "./DocumentItemLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports